import { cn } from '@/utlis/cn'

export default function InternalCard({ className, children }: { className?: string; children: React.ReactNode }) {
    const commonBorder = 'rounded-full'
    const commonStyle = 'inline-flex items-center justify-center px-6'
    const style = 'relative overflow-clip'
    const bg = 'bg-muse-yellow'

    return <div className={cn(commonStyle, style, commonBorder, bg, className)}>{children}</div>
}
